// Modules
import React from "react";

// Styles
import "./MvCheckBox.sass";

type Props = {
  labelStyle?: React.CSSProperties;
  name?: string;
  id?: string
  label: string;
  checked?: boolean;
  class?: string
  onChange: (e: any) => void;
  tabIndex?: number;
  dataTestId?: string;
  disabled?: boolean;
}

class MvwCheckbox extends React.Component<Props, {}> {
  container : any;

  onKeyDown(e: any) {
    if (e.keyCode === 32) {
      e.preventDefault();
      this.props.onChange(e);
    }
  }

  render() {
    let labelStyle = Object.assign(
      {},
      this.container,
      this.props.labelStyle || {}
    );

    const classNames = ["check-container"];

    // disabled
    const disabled = this.props.disabled === true;
    if (disabled) classNames.push("disabled");

    // checked
    const checked = this.props.checked;

    return (
      <div
        style={labelStyle}
        tabIndex={this.props.tabIndex ? this.props.tabIndex : 0}
        aria-checked={checked}
        className={classNames.join(" ")}
        role="checkbox"
        onKeyDown={(e) => this.onKeyDown(e)}
        data-name={this.props.name}
        data-testid={`${this.props.dataTestId}-wrapper`}
        >
          <label
            className={!this.props.class ? "rt-label" : "rt-label " + this.props.class}
            htmlFor={this.props.id ? this.props.id : ""}
          >
              {this.props.label}
          </label>
          <div className={`check-mark ${checked ? "checked" : ""}`}>
            <input
              id={this.props.id ? this.props.id : ""}
              name={this.props.name}
              className="checkbox"
              type="checkbox"
              checked={checked}
              tabIndex={-1}
              data-testid={this.props.dataTestId}
              onChange={this.props.onChange}
              disabled={disabled}
            />
          </div>
      </div>
    );
  }
}
export default MvwCheckbox;
